import { PAGE_ENTER_DEFAULT_STYLE, PAGE_EXIT_DEFAULT_UP_STYLE, PAGE_STYLE } from '../page'
import { HomeHeader } from './home-header'
import router from '../../../base/lib/router'
import { HomeContents } from './home-contents'
import { Base } from '../../../base/components/base'
import ldb from '../../../base/lib/ldb'
import { waitFor } from '../../../base/utils/wait'
import { TabTitles } from './tab-titles/tab-titles'
import { Div } from '../../../base/components/native/div'
import { CadTab } from './tabs/cad/cad'
import { USDTab } from './tabs/usd/usd'
import { BannersTab } from './tabs/banners/banners'
import { ToCadTab } from './tabs/tocad/tocad'
import { ArticlesTab } from './tabs/articles/articles'
import { CashTab } from './tabs/cash/cash'
import { FAQsTab } from './tabs/faqs/faqs'
import { AnalyticsTab } from './tabs/analytics/analytics'

export const HomePage = () => {

    const base = Base()
    base.cssClass(PAGE_STYLE)

    const header = HomeHeader()
    base.append(header)

    const contents = HomeContents()
    const tabTitles = TabTitles()
    contents.append(tabTitles)

    const tabsContent = Div()
    const tocad = ToCadTab()
    const cad = CadTab()
    const usd = USDTab()
    const cash = CashTab()
    const banners = BannersTab()
    const articles = ArticlesTab()
    const analytics = AnalyticsTab()
    const faqs = FAQsTab()
    tabsContent.append(tocad, cad, usd, cash, banners, articles, analytics, faqs)
    contents.append(tabsContent)
    base.append(contents)

    let selected = tocad
    tocad.show()
    tabTitles.on('select', (tab: keyof typeof tabOptions) => {
        selected.hide()
        const tabOptions = {
            faqs,
            articles,
            tocad,
            cad,
            usd,
            cash,
            banners,
            analytics,
        }

        selected = tabOptions[tab] || banners
        selected.show()
    })

    contents.on('scroll', (v: number) => v > 10 ? header.showShadow() : header.hideShadow())

    return Object.assign(base, {
        async enter() {
            await waitFor(300)
            if (!ldb.get('DANESH_FX_ADMIN_TOKEN')) {
                router.goto('/login')
            }
            base.style(PAGE_ENTER_DEFAULT_STYLE)

            // // else
            // contents.empty()
            // const socialMediaPrices = SocialMediaPrices()
            // contents.append(socialMediaPrices)
        },
        exit() {
            base.style(PAGE_EXIT_DEFAULT_UP_STYLE)
        }
    })
}